import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Box } from "@mui/material";

import { getReportRangeErrorMessage } from "src/utils/report/reportRange.util";

import { PageLayout } from "../../layouts/PageLayout";
import { CardLayout, EmptyState, PageHeader } from "../../components/v3";
import { UserReportForm, UserReportResults } from "../../components/report";
import { AnalyticsService } from "../../services";

export const UserReport = () => {
  const [loading, setLoading] = useState(false);
  const [reportFilters, setReportFilters] = useState(null);
  const [reportData, setReportData] = useState({});
  const [activeTab, setActiveTab] = useState("summary");
  const [paginationState, setPaginationState] = useState({ page: 0, pageSize: 10 });

  useEffect(() => {
    setReportData({});
  }, [activeTab]);

  const fetchData = async (filters, { onError } = {}) => {
    try {
      const { data } = await AnalyticsService.getUserReport(filters);
      setReportData(data);
    } catch (error) {
      onError?.();
      toast.error((await getReportRangeErrorMessage(error)) ?? "Failed to generate report");
      console.error("Error fetching user report data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGenerate = (filters, { onError } = {}) => {
    setLoading(true);
    setReportData({});
    setReportFilters(filters);
    setPaginationState({ page: 0, pageSize: 10 });
    fetchData(
      {
        ...filters,
        page: 1,
        limit: 10,
      },
      { onError },
    );
  };

  const handlePaginationChange = (model) => {
    setPaginationState(model);
    fetchData({
      ...reportFilters,
      page: model.page + 1,
      limit: model.pageSize,
    });
  };

  const reportType = [
    { label: "Summary", onClick: () => setActiveTab("summary") },
    { label: "Details", onClick: () => setActiveTab("details") },
  ];

  return (
    <PageLayout>
      {/* header section */}
      <Box sx={{ position: "relative", zIndex: 1 }}>
        <PageHeader
          // title
          title="User Report"
          chipItems={reportType}
          activeTab={activeTab}
        />
      </Box>

      {/* form section */}
      <Box sx={{ mt: -7, zIndex: 2, position: "relative" }}>
        <UserReportForm
          reportType={activeTab === "summary" ? "summary" : "detailed"}
          handleClear={() => setReportData({})}
          onGenerate={handleGenerate}
        />
      </Box>

      {/* results section */}
      {!loading &&
        reportData?.count !== undefined &&
        (reportData?.count > 0 ? (
          <UserReportResults
            reportType={activeTab === "summary" ? "summary" : "detailed"}
            data={reportData}
            loading={loading}
            paginationState={paginationState}
            handlePaginationChange={handlePaginationChange}
            reportFilters={reportFilters}
          />
        ) : (
          <CardLayout>
            <EmptyState title="No Data Found" subtitle="No report found for selected filters!" />
          </CardLayout>
        ))}
    </PageLayout>
  );
};
